/* eslint-disable import/no-default-export */
class ClientConfig {
  config: { [key: string]: string | boolean | { [key: string]: string } };
  constructor(config = {}) {
    this.config = { ...config };
  }
  get(name: string) {
    return this.config[name] || null;
  }
}
export default new ClientConfig(window.init_config);



// WEBPACK FOOTER //
// ./app/common/debug/client-config.ts